import React from 'react';
import { Link } from 'react-router-dom';
import { FiGithub, FiLinkedin, FiMail, FiPhone } from 'react-icons/fi';
import { motion } from 'framer-motion';

const socialLinks = [
  { icon: FiGithub, href: 'https://github.com/asharSQA', label: 'GitHub' },
  { icon: FiLinkedin, href: 'https://www.linkedin.com/in/ashar-tariq/', label: 'LinkedIn' },
  { icon: FiMail, href: 'mailto:ashar.sqa@gmail.com', label: 'Email' },
  { icon: FiPhone, href: 'tel:+923017022784', label: 'Phone' },
];

const ProfileTopSection = () => (
  <section id="home" className="w-full bg-white dark:bg-dark-100 py-12 md:py-20 transition-colors duration-300">
    <div className="container-custom flex flex-col md:flex-row items-center justify-center gap-12">
      {/* Left: Image + Socials */}
      <div className="flex flex-col items-center w-full lg:w-1/3">
        <div className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 lg:w-56 lg:h-56 bg-white dark:bg-gray-200 rounded-full flex items-center justify-center shadow-lg border-4 border-primary-500 mb-4 sm:mb-6">
          <img
            src="/avatar.png"
            alt="Ashar Tariq"
            className="w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 lg:w-52 lg:h-52 rounded-full object-cover"
          />
        </div>
        <div className="flex gap-3 sm:gap-4 mt-2 mb-4 sm:mb-6">
          {socialLinks.map((social) => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary-600 dark:text-white hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 touch-target"
              aria-label={social.label}
            >
              <social.icon className="w-5 h-5 sm:w-6 sm:h-6" />
            </a>
          ))}
        </div>
      </div>

      {/* Right: Details + Buttons */}
      <div className="flex flex-col items-center lg:items-start w-full lg:w-2/3">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-secondary-800 dark:text-white mb-6 leading-tight"
        >
          Hi, I'm{' '}
          <span className="gradient-text">Ashar Tariq</span>
        </motion.h1>
        <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-3 sm:mb-4">
          <span className="block mx-auto font-bold text-gray-300 text-sm sm:text-base md:text-lg">
            QA Automation Engineer
          </span>
        </div>
        <p className="text-sm sm:text-base md:text-lg text-secondary-700 dark:text-gray-100 mb-4 sm:mb-6 leading-relaxed text-center lg:text-left max-w-2xl px-2 sm:px-0">
          Software Quality Assurance Engineer with 4+ years of experience testing SaaS, healthcare, AI-driven, and CRM-based web applications. Strong background in manual testing, Cypress-based automation, regression testing, and defect management. Experienced in validating complex business workflows and working closely with development teams in Agile environments to ensure stable releases and high product quality.
        </p>
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-2 w-full justify-center lg:justify-start mb-4 sm:mb-6">
          <a
            href="/Ashar_Tariq_QA_Engineer_CV.pdf"
            download
            className="bg-primary-600 text-white px-6 sm:px-8 py-3 rounded-lg font-medium hover:bg-primary-700 transition-colors duration-200 flex items-center gap-2 touch-target text-sm sm:text-base justify-center"
          >
            <span>&#8681;</span> Download Resume
          </a>
          <Link
            to="/projects"
            className="border-2 border-primary-600 text-primary-600 px-6 sm:px-8 py-3 rounded-lg font-medium hover:bg-primary-600 hover:text-white transition-colors duration-200 touch-target text-sm sm:text-base justify-center text-center"
          >
            View Projects
          </Link>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.0 }}
          className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl lg:mx-0 mx-auto"
        >
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-primary-600 dark:text-primary-400 mb-2">4+</div>
            <div className="text-secondary-600 dark:text-gray-100 text-sm sm:text-base">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-primary-600 dark:text-primary-400 mb-2">10+</div>
            <div className="text-secondary-600 dark:text-gray-100 text-sm sm:text-base">Projects Completed</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-primary-600 dark:text-primary-400 mb-2">100%</div>
            <div className="text-secondary-600 dark:text-gray-100 text-sm sm:text-base">Quality Focus</div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default ProfileTopSection;
